/**
 * SEO Utility Functions
 */

import { isWordPressUrl } from './wordpressUrlDetector';

export const formatTitle = (title, template = 'default') => {
  const seoConfig = require('../config/seoConfig').default;
  const templateStr = seoConfig.titleTemplates[template] || seoConfig.titleTemplates.default;
  return templateStr.replace('%s', title);
};

export const generateCanonicalUrl = (path, baseUrl) => {
  const base = baseUrl || (typeof window !== 'undefined' ? window.location.origin : '');
  if (isWordPressUrl(path)) return base;
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
};

export const truncateMetaDescription = (text, maxLength = 160) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3).trim() + '...';
};

export const truncateMetaTitle = (text, maxLength = 60) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3).trim() + '...';
};

export const formatKeywords = (keywords) => {
  if (!keywords) return [];
  if (Array.isArray(keywords)) return keywords.filter((k) => k && k.trim()).map((k) => k.trim());
  if (typeof keywords === 'string') return keywords.split(',').map((k) => k.trim()).filter((k) => k);
  return [];
};

export const generateRobotsContent = (options = {}) => {
  const { noindex = false, nofollow = false } = options;
  return [noindex ? 'noindex' : 'index', nofollow ? 'nofollow' : 'follow'].join(', ');
};
